import { render, staticRenderFns } from "./Programacao.vue?vue&type=template&id=8c2700fc&scoped=true&"
import script from "./Programacao.vue?vue&type=script&lang=ts&"
export * from "./Programacao.vue?vue&type=script&lang=ts&"
import style0 from "./Programacao.vue?vue&type=style&index=0&id=8c2700fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2700fc",
  null
  
)

export default component.exports